import {HelpRequestApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import {Option} from "ts-option";

export default class HelpRequest {
	/**
	 * Help request
	 * @param {string} name
	 * @param {string} organization
	 * @param {string} email
	 * @param {string} contactNumber
	 * @param {string} requestText
	 * @param {string} browserVersion
	 * @param {string} uiVersion
	 */
	constructor(public readonly name: string,
		public readonly organization: string,
		public readonly email: string,
		public readonly contactNumber: Option<string>,
		public readonly requestText: string,
		public readonly browserVersion: string,
		public readonly uiVersion: string) {}

	toJson(): HelpRequestApiDto {
		const json: HelpRequestApiDto = {
			name: this.name,
			organization: this.organization,
			email: this.email,
			contactNumber: this.contactNumber.orNull,
			request: this.requestText,
			browserVersion: this.browserVersion,
			uiVersion: this.uiVersion
		};
		return JsonConverter.removeEmptyFields(json);
	}
}